import React, { useEffect, useState } from 'react'
import "./styles.css";
import AuthHeader from './AuthHeader';
import AuthMagilHub from './AuthMagilHub';
import AuthLogin from './Login';
import { getCountryRequest } from 'common/features/auth/AuthActions';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import AuthGuest from './GuestRegister';
import AuthRegister from './Register';
import AuthVerifyOTP from './VerifyOTP';
import AuthForgotPassword from './ForgotPassword';
import AuthResetPassword from './ResetPassword';
import AuthSuccessResetPassword from './SuccessResetPassword';

export interface AuthDesktopViewTypes { types:'LOGIN'|'REGISTER'|'GUEST'|'OTP'|'FORGOT_PASSWORD'|'RESET_PASSWORD'|'SUCCESS_RESET_PASSWORD'};

export interface AuthDesktopInterface{
  isOpen:boolean;
  setIsOpen:(key:boolean)=>void;
}

const AuthDesktop = (props:AuthDesktopInterface) => {

  const { isOpen,setIsOpen} = props;


  const history = useHistory();
  const dispatch = useDispatch();

    const [headerTitle,setHeaderTitle] = useState('Login')
    const [isShowBackArrow,setIsShowBackArrow] = useState(true)
    const [isShowCloseButton,setIsShowCloseButton] = useState(false)
    const [isShowLogo,setIsShowLogo] = useState(false)
    const [otpPayload,setOtpPayload] = useState(null)

    const [currentActivePage,setCurrentActivePage] = useState('LOGIN')
    const [currentActiveBackPage,setCurrentActiveBackPage] = useState('LOGIN')
    const [SuccessPageType,setSuccessPageType] = useState('reset')
    const [otpType,setotpType] = useState('')

    useEffect(() => {
      dispatch(getCountryRequest());
  }, []);

    const handleHeaderOnBack = () =>{
      handleOnPageSwitch(currentActiveBackPage)
    }

    const handleHeaderOnClose = () =>{
      setIsOpen(false)
    }

    useEffect(() => {
      setIsShowBackArrow( (currentActivePage == 'REGISTER'|| currentActivePage == 'GUEST' || currentActivePage == 'FORGOT_PASSWORD' || currentActivePage == 'OTP' || currentActivePage == 'RESET_PASSWORD' || currentActivePage == 'SUCCESS_RESET_PASSWORD') ? true : false)
      setIsShowCloseButton( (currentActivePage=='LOGIN' || currentActivePage == 'REGISTER'|| currentActivePage == 'GUEST' || currentActivePage == 'FORGOT_PASSWORD' || currentActivePage == 'RESET_PASSWORD' || currentActivePage == 'SUCCESS_RESET_PASSWORD') ? true : false)
      setIsShowLogo((currentActivePage ===  'LOGIN' || currentActivePage === 'REGISTER'|| currentActivePage === 'GUEST')?true:false)
      setHeaderTitle(currentActivePage ===  'LOGIN' ? 'Login' : currentActivePage === 'REGISTER'? 'Create new account' : currentActivePage === 'GUEST'? 'Guest Login': currentActivePage ===  'OTP' ? 'OTP Verification' : currentActivePage ===  'FORGOT_PASSWORD' ? 'Forgot Password' : currentActivePage === 'RESET_PASSWORD' ? 'Reset Password':'')
    }, [currentActivePage])


    const handleOnSuccess= (currentParamActivePage:string, payloadData:any)=>{
      handleOnPageSwitch(currentParamActivePage)
      setOtpPayload(payloadData)
    }
    

    const handleOnPageSwitch = (currentSwitchActivePage:string)=>{
      switch(currentSwitchActivePage){
        case 'LOGIN':
          setCurrentActivePage('LOGIN')
          setCurrentActiveBackPage('LOGIN')
          break;
        case 'REGISTER':
          setCurrentActivePage('REGISTER')
          setCurrentActiveBackPage('LOGIN')
          break;
        case 'GUEST':
          setCurrentActivePage('GUEST')
          setCurrentActiveBackPage('LOGIN')
          break;
        case 'FORGOT_PASSWORD':
          setCurrentActivePage('FORGOT_PASSWORD')
          setCurrentActiveBackPage('LOGIN')
          break;
        case 'RESET_PASSWORD' || 'OTP_RESET_PASSWORD':
          setCurrentActivePage('RESET_PASSWORD')
          setCurrentActiveBackPage('FORGOT_PASSWORD')
          break;
        case 'FORGOT_PASSWORD_OTP':
          setCurrentActivePage('OTP')
          setCurrentActiveBackPage('FORGOT_PASSWORD')
          setotpType('reset_password')
          break;
        case 'REGISTER_OTP':
          setCurrentActivePage('OTP')
          setCurrentActiveBackPage('REGISTER')
          setotpType('register_password')
          break;
        case 'GUEST_OTP':
          setCurrentActivePage('OTP')
          setCurrentActiveBackPage('GUEST')
          break;
        case 'SUCCESS_RESET_PASSWORD':
          setSuccessPageType('reset')
          setCurrentActivePage('SUCCESS_RESET_PASSWORD')
          setCurrentActiveBackPage('LOGIN')
          break;
        
      }
    }

    const handleOnOTPSuccess = (data:any)=>{
      switch(data){
        case 'REGISTER':
          setSuccessPageType('register')
          setCurrentActivePage('SUCCESS_RESET_PASSWORD')
          setCurrentActiveBackPage('LOGIN')
          break;
        case 'GUEST':
          handleHeaderOnClose()
          break;
        case 'FORGOT_PASSWORD':
          setCurrentActivePage('RESET_PASSWORD')
          setCurrentActiveBackPage('FORGOT_PASSWORD')
          break;
        case 'RESET_PASSWORD_SUCCESS':
          setSuccessPageType('reset')
          setCurrentActivePage('SUCCESS_RESET_PASSWORD')
          setCurrentActiveBackPage('LOGIN')
          break;
      }
    }

    const handleLoginSuccess = (data:any)=>{
      handleHeaderOnClose()
    }

  return (
    <React.Fragment>
        <div id="modal-background-ad">
            <div id="container-main-ad">
                <AuthHeader isShowBackArrow={isShowBackArrow} isShowCloseButton={isShowCloseButton} title={headerTitle} onBack={handleHeaderOnBack} onClose={handleHeaderOnClose}/>
                { currentActivePage === 'LOGIN' ? <AuthLogin handleOnPageSwitch={handleOnPageSwitch} handleLoginSuccess={handleLoginSuccess}/>  :
                currentActivePage === 'REGISTER' ?  <AuthRegister handleOnPageSwitch={handleOnPageSwitch} handleOnSuccess={handleOnSuccess}/> :
                currentActivePage === 'GUEST' ?  <AuthGuest handleOnPageSwitch={handleOnPageSwitch} handleOnSuccess={handleOnSuccess} handleLoginSuccess={handleLoginSuccess}/> :
                currentActivePage === 'OTP' ? <AuthVerifyOTP handleOnPageSwitch={handleOnPageSwitch} otpPayload={otpPayload} currentActivePage={currentActivePage} currentActiveBackPage={currentActiveBackPage} handleOnOTPSuccess={handleOnOTPSuccess} otpType={otpType}/> :
                currentActivePage ==='FORGOT_PASSWORD' ?  <AuthForgotPassword handleOnPageSwitch={handleOnPageSwitch} handleOnSuccess={handleOnSuccess}/> :
                currentActivePage === 'RESET_PASSWORD' ? <AuthResetPassword handleOnPageSwitch={handleOnPageSwitch} handleOnOTPSuccess={handleOnOTPSuccess}/> :
                currentActivePage === 'SUCCESS_RESET_PASSWORD' ? <AuthSuccessResetPassword handleOnPageSwitch={handleOnPageSwitch} successType={SuccessPageType}/> :

                <AuthLogin  handleOnPageSwitch={handleOnPageSwitch} handleLoginSuccess={handleLoginSuccess}/>}
            </div>
        </div>
    </React.Fragment>
  )
}

export default AuthDesktop